import { InputAdornment, IconButton } from "@mui/material";

interface IStartAdornmentProps {
	src: string;
	alt: string;
}

export default function StartAdornment(props: Readonly<IStartAdornmentProps>) {
	return (
		<InputAdornment position="start" className="pl-[6px] mr-[15px]">
			<IconButton edge="start" disabled>
				{<img src={props.src} alt={props.alt} />}
			</IconButton>
		</InputAdornment>
	);
}
